import {useEffect, useRef} from 'react';
import {FormattedMessage} from 'react-intl';
import {observer} from 'mobx-react';
import {Avatar, HtmlRender} from 'shared/components';
import NewEntry from './NewEntry';
import FeedbackSentiment from './FeedbackSentiment';
import EmailEntry from './EmailEntry';
import InterviewGuideResponseEntry from './InterviewGuideResponseEntry';
import InterviewInviteActionEntry from './interview_invite_action_entry';
import StageChangeEntry from './StageChangeEntry';
import QualificationStatusChangeEntry from './QualificationStatusChangeEntry';
import PositionChangeEntry from './PositionChangeEntry';
import UploadEntry from './UploadEntry';
import OfferEntry from './OfferEntry';
import RatingEntry from './RatingEntry';
import EntryRightMenu from './EntryRightMenu';

const TimelineEntry = ({candidate, entry, detailsState, sectionViewModel}) => {
  const feedbackEl = useRef(null);

  useEffect(() => {
    if (feedbackEl.current && location.href.includes(`feedback-${entry.id}`)) {
      feedbackEl.current.scrollIntoView({block: 'center'});
    }
  }, []);

  if (entry.isPositionChange) {
    return <PositionChangeEntry entry={entry} />;
  }

  if (entry.isQualificationStatusChange) {
    return <QualificationStatusChangeEntry entry={entry} />;
  }

  if (entry.isStageChange) {
    return <StageChangeEntry entry={entry} />;
  }

  if (entry.isEmail) {
    return <EmailEntry entry={entry} candidate={candidate} detailsState={detailsState} />;
  }

  if (entry.isUpload) {
    return <UploadEntry entry={entry} detailsState={detailsState} />;
  }

  if (entry.isInterviewGuideResponse) {
    return <InterviewGuideResponseEntry entry={entry} detailsState={detailsState} candidate={candidate} />;
  }

  if (entry.isInterviewInviteAction) {
    return <InterviewInviteActionEntry entry={entry} candidate={candidate} detailsState={detailsState} />;
  }

  if (detailsState.isBeingEdited(entry)) {
    return <NewEntry detailsState={detailsState} sectionViewModel={sectionViewModel} entry={entry} />;
  }

  if (entry.isOffer) {
    return <OfferEntry entry={entry} candidate={candidate} detailsState={detailsState}/>;
  }

  if (entry.isRating) {
    return <RatingEntry entry={entry} detailsState={detailsState} candidate={candidate} />;
  }

  return (
    <div className='flex gap-6 border-top p3' ref={feedbackEl}>
      <Avatar employee={entry.user} size='sm'/>
      <div className='flex-1'>
        <div className='flex justify-between'>
          <div>
            <div className='flex items-center gap-2'>
              <div className='h3 medium'>
                <FormattedMessage id='recruiting.hiring_funnel.Feedback'/>
              </div>
              <div className='h5 jumbo'>{entry.date}</div>
            </div>
            <div className='h5 jumbo'>{entry.name}</div>
          </div>
          <EntryRightMenu detailsState={detailsState} entry={entry}/>
        </div>
        <div className='pt2 whitespace-pre-line word-break'>
          <HtmlRender html={entry.text}/>
        </div>
        {entry.isFeedback && entry.sentiment && <FeedbackSentiment isPositive={entry.isPositiveSentiment}/>}
      </div>
    </div>
  );
};

export default observer(TimelineEntry);
